/* eslint-disable no-underscore-dangle */
import { FETCH_DELIVERIES, SET_DELIVERY_DRAFT } from '../constant/actionType';

export const initialState = {
  deliveries: [],
  deliveriesDraft: []
};

const deliveryReducer = (state = initialState, { type, data }) => {
  switch (type) {
    case FETCH_DELIVERIES: {
      return {
        ...state,
        deliveries: data,
        deliveriesDraft: data
      };
    }

    case SET_DELIVERY_DRAFT: {
      return {
        ...state,
        deliveriesDraft: data
      };
    }

    default:
      return state;
  }
};

export default deliveryReducer;
